export const environment = {
  production: false,
  apiUrl: 'https://fayaport80.fayastage.com:7000/api'
};
